import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Box } from '@mui/material';
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';
import CustomDivider from './shared/utils/CustomDivider';
import ScrollToTop from './shared/utils/ScrollToTop';
import { AppRoutes } from './routes';

function App() {
  return (
    <Router>
      <Box sx={{ minHeight: "100vh" }}>
        <Navbar />
        <CustomDivider orientation='horizontal' size={20} />
        <ScrollToTop />
        <Routes >
          {AppRoutes.map((item) => (
            <Route key={item.path} path={item.path} element={<item.Component />} />
          ))}
        </Routes>
        <CustomDivider orientation='horizontal' />
        <Footer />
      </Box>

    </Router>
  );
}

export default App;
